// Общий вид вкладок админки — по образцу «Пользователей» (UsersTab.js):
// таблица на карточке, серая строка заголовка, фильтры плашками.
// Одно место на все вкладки: 28.09.2026 владелец заметил, что «Оплаты»,
// «Заявки на счёт», «Пробный месяц» и «Организации» выглядят каждая по-своему —
// классы переписывались руками и расходились.
export const HEAD_ROW = 'bg-paper-panel border-b text-left';
export const TH = 'px-3 py-2.5 font-medium text-paper-ink-3';
export const TD = 'px-3 py-2.5';
export const ROW = 'border-b last:border-b-0';
export const SELECT = 'px-3 py-2 rounded-chip bg-paper-bg text-sm';
export const BADGE = 'inline-block text-xs rounded-full px-2 py-0.5 whitespace-nowrap';
export const TITLE = 'text-sm font-semibold text-paper-ink';
export const HINT = 'text-xs text-paper-hint';
export const EMPTY = 'text-center py-8 text-paper-hint';
export const ERROR_BOX = 'bg-paper-accent/[0.06] text-paper-accent rounded-panel p-3 text-sm';
export const NOTE_BOX = 'bg-paper-panel rounded-panel p-3 text-sm text-paper-ink';
export const ACCENT_BTN = 'bg-paper-accent hover:bg-paper-accent-hover';
export const FIELD_LABEL = 'text-xs text-paper-ink-3';
